GroupEventService = ($http ,$q ,groupUploadDataService ,groupRegisDataService )  ->

  getEvent = (id) ->
    defer = $q.defer()
    url = "/api/group_events/#{id}.json"
    $http.get(url).then (resp) ->
      defer.resolve resp.data
    defer.promise

  checkJoinGroup:(id) ->
    defer = $q.defer()
    url = "/api/users/join_group.json?group_id=#{id}"
    $http.get(url).then (resp) ->
      defer.resolve resp.data
    defer.promise

  createEvent:(event , dataCover) ->
    defer = $q.defer()
    promise =
      urlCover: groupUploadDataService.uploadS3(dataCover.coverFile ,dataCover.url , dataCover.fields )

    $q.all(promise).then (data) ->
      event.cover_path = data.urlCover
      $http.post('/api/group_events.json', event)
        .then (data) ->
          defer.resolve 'success'
        , (data) ->
          defer.reject data
    defer.promise

  updateEvent:(event , dataCover) ->
    defer = $q.defer()
    promise =
      urlCover: groupUploadDataService.uploadS3(dataCover.coverFile ,dataCover.url , dataCover.fields )
    url = "/api/group_events/#{event.id}.json"
    $q.all(promise).then (data) ->
      event.cover_path = data.urlCover
      $http.put(url , event)
        .then (data) ->
          defer.resolve 'success'
        , (data) ->
          defer.reject data
    defer.promise

  deleteEvent: (id) ->
    url = "/api/group_events/#{id}.json"
    $http.delete(url)

  listEvent:(dParam) ->
    defer = $q.defer()
    url = "/api/groups/#{dParam.id}/list_event.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  listScoreCardByEvent: (dParam) ->
    defer = $q.defer()
    url = "/api/group_events/#{dParam.id}/list_score_card.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  listEventRanking: (dParam) ->
    defer = $q.defer()
    url = "/api/group_events/#{dParam.id}/ranking_users.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  getCourses: (dParam) ->
    defer = $q.defer()
    url = "/api/group_events/#{dParam.id}/courses.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  getDataEventDetail: (id) ->
    defer = $q.defer()
    promise =
      eventDetail: getEvent(id)
    $q.all(promise).then (data) ->
      reData =
        eventDetail: data.eventDetail
      groupRegisDataService.getGroup(data.eventDetail.group_id).then (data) ->
        reData.groupDetail = data
        defer.resolve reData
    defer.promise

  submitScoreCard: (dParams) ->
    url = '/api/event_score_cards.json'
    $http.post url , dParams

  unSubmitScoreCard: (dParam) ->
    url = "/api/event_score_cards/score_card.json?score_card_id=#{dParam.score_card_id}&group_event_id=#{dParam.group_event_id}"
    $http.delete(url, dParam)

GroupEventService.$inject = [
  '$http'
  '$q'
  'groupUploadDataService'
  'groupRegisDataService'
]

module.exports = GroupEventService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/group-event-service.coffee